"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckboxStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.getCheckboxStyles = (0, Utils_1.createStyleSheet)((theme) => ({
    checkbox: {
        flexShrink: 0,
        width: theme.spacing.$s5,
        height: theme.spacing.$s5,
        cursor: 'pointer',
        border: `2px solid ${theme.colors.$neutral300}`,
        borderRadius: '4px',
        backgroundColor: 'transparent',
        position: 'relative',
        '&:hover': {
            borderColor: theme.colors.$interactivePrimaryDefault,
        },
    },
    checkboxSmall: {
        width: theme.spacing.$s4,
        height: theme.spacing.$s4,
    },
    checkboxChecked: {
        backgroundColor: theme.colors.$interactivePrimaryDefault,
        borderColor: theme.colors.$interactivePrimaryDefault,
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '45%',
            left: '50%',
            width: '6px',
            height: '12px',
            border: 'solid white',
            borderWidth: '0 3px 3px 0',
            transform: 'translate(-50%, -50%) rotate(45deg)',
            pointerEvents: 'none',
        },
    },
    checkboxWrapper: {
        display: 'flex',
        padding: theme.spacing.$s1,
        alignItems: 'flex-start',
        gap: theme.spacing.$s3,
        width: '100%',
    },
    label: Object.assign(Object.assign({}, theme.typography.$textSecondary200), { color: theme.colors.$content100, cursor: 'pointer', textTransform: 'none', marginTop: '2px', flex: 1 }),
}), { name: 'Blueprint-Checkbox' });
